<div class="margin-mcm" [ngSwitch]="mode">
    <ng-container *ngSwitchCase="'item-warning'">
        <div class="margin-mcm__section">
            <i class="pi pi-exclamation-circle margin-mcm__icon" aria-hidden="true"></i>
            <p>{{ itemWarningMessage }}</p>
        </div>

        <div class="margin-mcm__notice margin-mcm__notice--warn">
            <i class="pi pi-info-circle margin-mcm__notice-icon" aria-hidden="true"></i>
            <span>{{ itemWarningNote }}</span>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'blocked'">
        <div class="margin-mcm__section">
            <i class="pi pi-info-circle margin-mcm__icon" aria-hidden="true"></i>
            <p>{{ blockedThresholdMessage }}</p>
        </div>

        <div class="margin-mcm__divider" aria-hidden="true"></div>

        <div class="margin-mcm__section">
            <i class="pi pi-envelope margin-mcm__icon" aria-hidden="true"></i>
            <div class="margin-mcm__contacts">
                <p class="margin-mcm__prompt">Please obtain approval from:</p>
                <ul class="margin-mcm__email-list" *ngIf="contactEmails.length; else blockedFallbackContact">
                    <li *ngFor="let email of contactEmails">{{ email }}</li>
                </ul>
                <ng-template #blockedFallbackContact>
                    <p class="margin-mcm__fallback">{{ note }}</p>
                </ng-template>
            </div>
        </div>

        <div class="margin-mcm__notice margin-mcm__notice--info">
            <i class="pi pi-info-circle margin-mcm__notice-icon" aria-hidden="true"></i>
            <span>{{ blockedApprovalNotice }}</span>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'approval'">
        <div class="margin-mcm__section">
            <i class="pi pi-info-circle margin-mcm__icon" aria-hidden="true"></i>
            <p>{{ approvalThresholdMessage }}</p>
        </div>

        <div class="margin-mcm__divider" aria-hidden="true"></div>

        <div class="margin-mcm__section">
            <i class="pi pi-check-circle margin-mcm__icon" aria-hidden="true"></i>
            <p>{{ proceedNote }}</p>
        </div>

        <div class="margin-mcm__divider" aria-hidden="true"></div>

        <div class="margin-mcm__section">
            <i class="pi pi-envelope margin-mcm__icon" aria-hidden="true"></i>
            <div class="margin-mcm__contacts">
                <p class="margin-mcm__prompt">Approvers:</p>
                <ul class="margin-mcm__email-list" *ngIf="contactEmails.length; else approvalFallbackContact">
                    <li *ngFor="let email of contactEmails">{{ email }}</li>
                </ul>
                <ng-template #approvalFallbackContact>
                    <p class="margin-mcm__fallback">{{ note }}</p>
                </ng-template>
            </div>
        </div>
    </ng-container>
</div>
